import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Select, Store } from '@ngxs/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subject, switchMap } from 'rxjs';
import { SimulationTrackerState } from 'src/app/state/simulation-tracker/simulation-tracker.state';
import { UserState } from 'src/app/state/user/user.state';
import { SimulationTrackerService } from '../../services/simulation-tracker.service';
import { NotificationsActions } from 'src/app/state/notifications/notifications.actions';
import { Severity } from 'src/app/global/enums/severity';

@Component({
  selector: 'app-simulation-warning-modal',
  templateUrl: './simulation-warning-modal.component.html',
  styleUrl: './simulation-warning-modal.component.scss'
})

export class SimulationWarningModalComponent implements OnInit {
  subheaderText: string = '';
  issueText: string = '';
  form: FormGroup = new FormGroup({});
  model: { simulationName: string } = { simulationName: '' };
  fields: FormlyFieldConfig[] = [];
  simulationNameAvailable: boolean = true;
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, private store: Store,
  private simulationTrackerService: SimulationTrackerService
  ) { }

  private simulationNameAvaliableClicked$ = new Subject<{
  field: FormlyFieldConfig;
  event: Event;
  }>();

  @Select(SimulationTrackerState.isSimulationNameAvailable)
   simulationNameAvaliable$!: Observable<boolean>;

  ngOnInit() {
    this.simulationNameAvailable = true;
    this.subheaderText = this.config.data.subheaderText;
    this.issueText = this.config.data.issueText;
    this.store.select(UserState.debuggerAccess)
          .subscribe(() => {
            this.setFields();
          });
    
  this.simulationNameAvaliableClicked$
  .pipe(
  switchMap(() => this.isSimulationNameUnique(this.model.simulationName)))
  .subscribe((isAvailable: boolean) => {
    if(isAvailable)
    {
      this.store.dispatch(
        new NotificationsActions.Toast(
          'Simulation name is in use, please use another one.',
           Severity.Error
        )
      );
    }
                        
  this.simulationNameAvailable = isAvailable;
  });
  }

  cancel() {
    this.ref.close(false);
  }

  startRun(model: { simulationName: string}) {
    this.ref.close(model);
  }


  onKeyDown(event: KeyboardEvent): void 
  {
      this.simulationNameAvaliable$.subscribe(
    () => (this.simulationNameAvailable = true));  

  }

  isSimulationNameUnique(simulationName: string): Observable<boolean> {
  return this.simulationTrackerService.isSimulationNameAvailable(simulationName);
}



   setFields(): void {
      this.fields = [
        {
          className: 'basin-width-100',
          key: 'simulationName',
          id: 'simulationName',
          type: 'textbox',
          props: {
            label: 'Simulation Name',
            type:'text',
            placeholder: 'Enter Simulation Name',
            required: true,            
            max: 50,
           description:
          "To check simulation name availability, click here.",
        actionDescription: true,
        actionDescriptionClicked:  this.simulationNameAvaliableClicked$,
            
          },
          validators: {
            maxTextLength: (c: AbstractControl, field: FormlyFieldConfig) => {
              const  max :number|undefined = (field.props)?.max;
              return !(max !== undefined && c.value?.length > max);
            },
          },
        },
      ];
    }
}